import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  border: 1px solid var(--primary);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  max-height: 680px;
  min-height: 680px;
  max-width: 656px;
  padding: 32px 24px;
  width: 100%;

  @media (max-width: 950px) {
    max-height: initial;
    min-height: initial;
    width: calc(100% - 16px);
  }
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h1 {
    line-height: 32px;
  }

  span {
    font-size: 13px;
    line-height: 15px;
  }
`

export const Form = styled.form`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px 16px;

  > div {
    &:nth-child(5),
    &:nth-child(6),
    &:nth-child(7) {
      grid-column: span 2;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 24px 0;

    > div {
      grid-column: 1;
    }
  }
`

export const TermsLink = styled(Link)`
  color: #568BE1;
  font-weight: 700;
  text-decoration: underline;
`

export const MessageSentContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  justify-content: center;
  max-width: 264px;

  p {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
  }

  span {
    color: #7649C6;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
    text-decoration: underline;
  }
`
